import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Link as RouterLink } from "react-router-dom";

import { BatchTicketsForm } from "../components/BatchTicketsForm";
import { OperationsList } from "../components/OperationsList";
import { SingleTicketForm } from "../components/SingleTicketForm";

export type RehydrationKind = "single" | "batch";

type RehydrationPageProps = {
  kind: RehydrationKind;
};

// onSubmitSuccess não é mais necessário — o useQueryClient dentro dos forms
// invalida a query ["operations"] e a OperationsList refetch sozinha.
export function RehydrationPage({ kind }: RehydrationPageProps) {
  return (
    <Paper elevation={0} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <Tabs
        value={kind}
        textColor="primary"
        indicatorColor="secondary"
        sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}
      >
        <Tab
          value="single"
          label="Um ticket"
          component={RouterLink}
          to="/single"
        />
        <Tab
          value="batch"
          label="Em lote"
          component={RouterLink}
          to="/batch"
        />
      </Tabs>

      <Box sx={{ p: 4 }}>
        {kind === "single" ? <SingleTicketForm /> : <BatchTicketsForm />}
      </Box>

      <Divider />

      <Box sx={{ p: 4 }}>
        <OperationsList />
      </Box>
    </Paper>
  );
}
